import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import { type GenericFiltersMap } from "../../../../../utils/filterUtils";
import { createFiltersSlice, type FiltersState } from "../../../../Application/slices/createFiltersSlice";
import { type FiltersEnum } from "../../types";

export interface AccountFiltersState extends FiltersState<FiltersEnum> {
  search?: string;
}

export const initialState: AccountFiltersState = {
  filterOptions: {} as GenericFiltersMap<FiltersEnum>,
  appliedFilter: {} as GenericFiltersMap<FiltersEnum>,
  isLoading: false,
};

const accountFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Accounts,
    entity: ReducerEntityPrefixTypes.Accounts,
    name: "filters",
  },
  initialState,
  reducers: {},
});

export const { setAppliedFilter, resetAppliedFilter, setIsLoading, setFilterOptions, resetFilter } =
  accountFiltersSlice.actions;

export default accountFiltersSlice.reducer;
